import {
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Mev = () => {
  return (
    <Container className="container-xxl my-4">
      <Box
        className="card p-4"
        sx={{
          minHeight: "500px",
        }}
      >
        <Box className="px-2 pb-3">
          <span
            className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium py-1.5 px-2 me-1"
            title="This feature is intended for advanced users"
          >
            Advanced
          </span>{" "}
          A set of information that represents the current{" "}
          <strong className="text-dark">state</strong> is updated when a
          transaction takes place on the network. The below is a summary of
          those changes :
        </Box>
        <Box className="table-responsive mb-2 mb-md-0">
          <Table className="table table-hover">
            <TableHead className="thead-light">
              <TableRow>
                <TableCell scope="col">&nbsp;</TableCell>
                <TableCell
                  scope="col"
                  className="font-weight-bold"
                  data-highlight=""
                >
                  Address
                </TableCell>
                <TableCell scope="col">&nbsp;</TableCell>
                <TableCell scope="col">Before</TableCell>
                <TableCell scope="col">After</TableCell>
                <TableCell scope="col">State Difference</TableCell>
                <TableCell scope="col" className="d-none">
                  Code
                </TableCell>
                <TableCell scope="col" className="d-none">
                  Nonce
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="align-middle text-nowrap">
              {/* <TableRow className="plus">
                <TableCell
                  id="0x388c818ca8b9251b393131c08a736a67ccb19297"
                  className="text-center"
                ></TableCell>
                <TableCell>
                  <span className="me-1">
                    <Link
                      href="/address/0x388c818ca8b9251b393131c08a736a67ccb19297"
                      target="_parent"
                      className="border px-1 border-0"
                    >
                      0x388C81...ccB19297
                    </Link>
                  </span>
                </TableCell>
                <TableCell>(Lido: Execution Layer Rewards Vault)</TableCell>
                <TableCell>151.471892198858257171 UPC</TableCell>
                <TableCell>151.76424782087087192 UPC</TableCell>
                <TableCell>
                  <ArrowDropDownIcon className="text-muted" />
                  0.292355622012614749
                </TableCell>
                <TableCell className="d-none"></TableCell>
              </TableRow>
              <TableRow className="plus">
                <TableCell className="text-center"></TableCell>
                <TableCell>
                  <span className="me-1">
                    <Link
                      href="/address/0x4838b106fce9647bdf1e7877bf73ce8b0bad5f97"
                      target="_parent"
                      className="border px-1 border-0"
                    >
                      0x4838B1...0BAD5f97
                    </Link>
                  </span>
                  <span className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium py-1.5 px-2">
                    Producer
                  </span>
                </TableCell>
                <TableCell>(Titan Builder)</TableCell>
                <TableCell>
                  <Box className="mb-1">41.855133146969524772 UPC</Box>
                  <Box className="mb-0">
                    <span className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium py-1.5 px-2">
                      Nonce: 166353
                    </span>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box className="mb-1">41.562074998977165624 UPC</Box>
                  <Box className="mb-0">
                    <span className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium py-1.5 px-2">
                      Nonce: 166354
                    </span>
                  </Box>
                </TableCell>
                <TableCell>
                  <ArrowDropDownIcon className="text-muted" />
                  0.293058147992359148
                </TableCell>
                <TableCell className="d-none"></TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Container>
  );
};

export default Mev;
